import { render, staticRenderFns } from "./EditSkill.vue?vue&type=template&id=3ff248c4&"
import script from "./EditSkill.vue?vue&type=script&lang=ts&"
export * from "./EditSkill.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports